<div class="row">
  <div class="">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <div class="">
      <div class="">
        <div>
          <div class="">
            <div class="">
              <div class="">
                <div class="">
                  <div class="">
                    <div class="image-container">
                      <img alt="trainingimg" class="training_image"
                        src="../../../assets/img/training_module/training_background.svg" />

                    </div>
                    <div class="align-items-center gap-2 ps-4 back_btn_block pointer" (keydown.enter)="redirectToBack()"
                      (click)="redirectToBack()">
                      <div class="d-flex ">
                        <div class="back_arrow">
                          <img src="../../../assets/img/training_module/right_arrow.svg" width="10px" height="9px"
                            alt="">

                        </div>&nbsp;
                        <span class="card_details text-white fw-medium">Back to Trainings</span>
                      </div><br>
                      <h5 class="training_name">
                        {{ trainingData.trainingName }}(v{{ trainingData.version }})
                      </h5><br>
                      <span class="card_details text-white">{{trainingData.dueDate | date : "dd-MMM-yyyy"}}</span>
                    </div>

                    <div class="training_data_block ps-4">
                      <img alt="backimg" style="width: 100%;"
                        src="../../../assets/img/training_module/backForImage.svg">
                    </div>

                    <div class="d-flex justify-content-start gap-3 mx-3">
                      <img alt="trainimg" class="small_training_image" height="80" width="120"
                        *ngIf="trainingData.trainingImage == null" src="../../../assets/img/missing.jpg" />
                      <img alt="trnimg" class="small_training_image" height="80" width="120"
                        *ngIf="trainingData.trainingImage != null" src="data:image/jpg;base64,{{
                          trainingData.trainingImage
                        }}" />
                      <div class="training_name_detail">
                        <h3 style="margin-top: -12%;margin-bottom: 2px;">{{trainingData.trainingName}}</h3>
                        <span>Status : <span class="card_details"
                            [ngClass]="trainingData.status === 'Completed' ? 'closed' : trainingData.status === 'Draft' ? 'draft' : trainingData.status === 'Failed' ? 'delete': 'approve'">{{
                            trainingData.status
                            }}</span></span>
                      </div>

                    </div>

                    <div class="d-flex justify-content-end  mx-3 button-continer details_button" mat-dialog-actions>

                      <button *ngIf="isSelfAssign && (trainingData.userTrainingStatus == 'Completed' && trainingData.status == 'Completed')" mat-stroked-button class="training_btn pull-right me-1"
                        (click)="selfAssignFunc()">
                        Self Assign
                      </button>
                      <button
                        *ngIf="(trainingData.levelStatus == 'Pending' || trainingData.levelStatus == 'Overdue') && trainingData.status !='Expired' && trainingData.status !='Obsoleted'"
                        mat-stroked-button class="training_btn pull-right me-1" (click)="startTraining('LAUNCH')">
                        Launch Training
                      </button>
                      <button *ngIf="trainingData.levelStatus == 'In Progress'" mat-stroked-button
                        class="training_btn pull-right me-1" (click)="startTraining('LAUNCH')">
                        Continue Training
                      </button>
                      <span *ngIf="trainingData.trainingScheduleId != null">
                        <button *ngIf="
                              trainingData.levelStatus == 'Completed' 
                            " mat-stroked-button class="certificate pull-right me-1" (click)="certificate()">
                          Certificate
                        </button>
                         <button *ngIf="trainingData.userTrainingStatus != 'Locked' &&
    trainingData.userTrainingStatus == 'Completed' && 
    (
      trainingData.type != 'Instructor-led Training' || 
      (trainingData.type == 'Instructor-led Training' && trainingData.scheduledTrainingStatus != 'Completed')
    )
  " mat-stroked-button class="training_btn pull-right me-1" (click)="reasonRelaunchFun()">
                          Re-Take Training
                        </button>
                      </span>
                      <span *ngIf="trainingData.trainingScheduleId == null">
                        <button *ngIf="trainingData.levelStatus == 'Completed'" mat-stroked-button
                          class="certificate pull-right me-1" (click)="certificate()">
                          Certificate
                        </button>
                        <button *ngIf=" trainingData.userTrainingStatus != 'Locked' &&
    trainingData.userTrainingStatus == 'Completed' && 
    (
      trainingData.type != 'Instructor-led Training' || 
      (trainingData.type == 'Instructor-led Training' && trainingData.scheduledTrainingStatus != 'Completed')
    )
  " mat-stroked-button class="training_btn pull-right me-1" (click)="reasonRelaunchFun()">
                          Re-Take Training
                        </button>
                      </span>
                      <button *ngIf="trainingData.levelStatus == 'Failed'" mat-stroked-button
                        class="training_btn pull-right me-1" (click)="startTraining('RELAUNCH')">
                        Redo Training
                      </button>
                      <button mat-stroked-button class="cancelButton pull-right me-4" (click)="redirectToBack()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" style="margin-top: 6%;">
              <div class="">
              </div>
              <div class="d-flex justify-content-between">
                <div class="col-md-5">
                  <div class="panel-heading">
                    <h5 class="panel-title">Details</h5>
                  </div>
                  <div>
                    <p class="card_details mt-3">Category : {{ trainingData.categoryCode }}</p>
                    <p class="card_details">Language : {{ trainingData.language }}</p>
                    <p *ngIf="trainingData.trainerName != null">Instructor Name : {{ trainingData.trainerName }}</p>
                    <p class="card_details mt-1" *ngIf="trainingData.groupName != null">Group : {{
                      trainingData.groupName }}</p>
                    <p *ngIf="trainingData.startDate != null">Start Date :
                      {{
                      trainingData.startDate | date : "dd-MMM-yyyy HH:mm:ss"
                      }}</p>
                    <span *ngIf="trainingData.EndDate != null">End Date :
                      {{
                      trainingData.EndDate | date : "dd-MMM-yyyy HH:mm:ss"
                      }}</span>
                  </div>
                </div>

                <div *ngIf="trainingData.description != null" class="col-md-6">
                  <div class="panel-heading">
                    <h5 class="panel-title">
                      Description
                    </h5>
                  </div>
                  <div>
                    <div class="card_details mt-3" [innerHtml]="trainingData.description"></div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="col-md-12">
                  <div class="panel-heading">
                    <h5 class="panel-title">Content(s)</h5>
                  </div>
                  <div class="mt-3">
                    <div class="" *ngFor="let content of contentList; let i = index">
                      <p class="card_details mt-1">
                        &nbsp;&nbsp;{{ i + 1 }}. {{ content.contentName
                        }}<span *ngIf="content.totalDuration != null">&nbsp;&nbsp;({{ content.totalDuration }})</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="caption card-footer text-center"></div>
    </div>
  </div>
</div>
<ng-template #reasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReasonFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label for="popup" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="email">Relaunch Reason</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reasonTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="reasonForRelaunch"></textarea>
          <span id="reasonTextarea-required-msg">Please update the reason for relaunch</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="reasonRelaunchFunction()">
        OK
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReasonFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #selfAssignPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSelfAssignFunc()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Self Assign</label>
    <label for="pop" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div>
      <div class="row">Are you sure you want to self assign this training?</div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="selfAssignOkFunc()">
        Self Assign
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSelfAssignFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #certificationPopup>
  <div class="ng-template-container" style="background-color: #f9f7f2;">
    <i class="fa fa-close pull-right"
      style="cursor: pointer;  color: black !important;right: 18px; font-size: 18px !important;" title="Close"
      (click)="closeCertificationpopup()" (keydown.enter)="closeCertificationpopup()"></i>
    <i class="fa fa-download pull-right" style="cursor: pointer;" title="Download" (click)="downloadAsPdf()"
      (keydown.enter)="downloadAsPdf()"></i>

    <div id="dataToExport" class="row" *ngIf="!isDefaultTemplate">
      <div class="col-md-10" style="margin-top: 2%;padding-left: 4%;margin-bottom: 2%;">
        <div class="row text-center">
          <span *ngIf="
              oneQmsOrgImagesDetails != null ||
              oneQmsOrgImagesDetails != undefined
            ">
            <img alt="orgimg" class="org-image" src="data:image/*;base64,{{ oneQmsOrgImagesDetails.logoImage }}"
              style="width: 60px; height: 60px" />
            <span style="display: inline-flex; width: 40%">{{
              orgData.orgLongName
              }}</span>
          </span>
        </div>
        <br />
        <div class="row text-center">
          <span class="cetificateTitle">Certificate of Completion</span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="color: gray; font-weight: 500"><i>This is to certify that</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{ userDetails.userNameAtApplication }}</span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="color: gray; font-weight: 500"><i>Has successfully completed the {{trainingData.type}}
              course</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{ trainingData.trainingName }}</span>
        </div>
        <div class="row text-center" style="margin-top: 2%"
          *ngIf="trainingData.finalScore!=null && trainingData.finalScore!=''">
          <span style="color: gray; font-weight: 500"><i>with score of {{ trainingData.finalScore }}% on</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{
            trainingData.completedOn | date : "dd-MMM-yyyy HH:mm:ss"
            }}</span>
          <small>{{timezone}}</small>
        </div>
        <hr style="border-top: 3px solid black" />
        <div class="row" *ngIf="isEsignRequired">
          <span style="color: gray; font-weight: 500"><i>{{ reasonForSign }} </i></span>
        </div>
        <div class="row" style="text-align: right; font-size: 11px; font-weight: 600" *ngIf="isEsignRequired">
          <span>{{ userDetails.userNameAtApplication}}</span>
          <span>{{ userDetails.designation }}</span>
          <span>{{
            trainingData.completedOn | date : "dd-MMM-yyyy HH:mm:ss"
            }}</span>
          <small>{{timezone}}</small>
          <span>I have read and understood training</span>
        </div>
      </div>
      <div class="col-md-2" style="
          height: auto;
          background-color: #f3caaf;
          width: 13%;
          margin-top: 2%;
          margin-bottom: 2%;
        "></div>
    </div>
    <div id="dataToExportFromTemp" *ngIf="isDefaultTemplate" [innerHTML]="certificateData"></div>
  </div>
</ng-template>